import cx from 'classnames';
import { PHONE, SIGNUP_AVATAR, SIGNUP_TITLE } from 'mk/autogenerated/translations/SignupProgressBar.4e426f93477aa50544a42cfbb08a7041'
import styles from 'mk2/apps/users/containers/Signup/SignupProgressBar.mscss';
import React from 'react';

interface OwnProps {
    lastCircleActive: boolean;
}

const SignupProgressBar: React.StatelessComponent<OwnProps> = ({ lastCircleActive }) => (
    <svg className={styles.ProgressBar__svg}>
        <circle className={styles.ProgressBar__emptyFirstCircle} />
        <line x1="45" y1="14" x2="50" y2="20" className={styles.ProgressBar__firstCheck} />
        <line x1="49" y1="20" x2="54" y2="9" className={styles.ProgressBar__firstCheck} />
        <line x1="60" y1="14" x2="145" y2="14" className={styles.ProgressBar__firstLine} />
        <line x1="165" y1="14" x2="250" y2="14" className={cx(styles.ProgressBar__secondLine, lastCircleActive && styles['ProgressBar__secondLine--active'])} />
        {lastCircleActive ? [
            <circle key="circle-2-1" className={styles.ProgressBar__emptySecondCircle} />,
            <line key="check-2-1" x1="150" y1="14" x2="155" y2="20" className={styles.ProgressBar__secondCheck} />,
            <line key="check-2-2" x1="154" y1="20" x2="159" y2="9" className={styles.ProgressBar__secondCheck} />,
        ] : [
            <circle key="circle-2-1" className={styles.ProgressBar__emptySecondCircle} />,
            <circle key="circle-2-2" className={styles.ProgressBar__fullSecondCircle} />,
        ]}

        <circle className={cx(styles.ProgressBar__emptyThirdCircle, lastCircleActive && styles['ProgressBar__emptyThirdCircle--active'])} />
        <circle className={cx(styles.ProgressBar__fullThirdCircle, lastCircleActive && styles['ProgressBar__emptyThirdCircle--active'])} />
        <text x="15" y="50" className={styles.ProgressBar__firstText}>{SIGNUP_TITLE}</text>
        <text x="130" y="50" className={cx(styles.ProgressBar__secondText)}>{PHONE}</text>
        <text x="220" y="50" className={cx(styles.ProgressBar__thirdText)}>{SIGNUP_AVATAR}</text>
    </svg>
);

export default SignupProgressBar;
